// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { ApplicationLayout } from '../Classes/ApplicationLayout';
import { MultiPdfLocalLibraryReports } from '../Classes/MultiPdfLocalLibraryReports';
export class SetUserDataRequest {
  userId: string;
  applicationLayout: ApplicationLayout;
  multiPdfLocalLibraryReports: MultiPdfLocalLibraryReports;
}
